export function sanitizeFilename(filename: string) {
  return filename.replace(/[%&+=?#/\\]/g, " ");
}

export const getSwanTransferRequestFilePath = ({
  accountId,
  transferId,
  fileId,
}: {
  accountId: string;
  transferId: string;
  fileId: string;
}) => `accounts/${accountId}/swanTransferRequests/${transferId}/files/${fileId}`;

export const getSwanTransactionFilePath = ({
  accountId,
  transactionId,
  fileId,
}: {
  accountId: string;
  transactionId: string;
  fileId: string;
}) => `accounts/${accountId}/swanTransactions/${transactionId}/files/${fileId}`;

export const getTreezorTransferRequestFilePath = ({
  accountId,
  transferId,
  fileId,
}: {
  accountId: string;
  transferId: string;
  fileId: string;
}) => `accounts/${accountId}/treezorTransferRequests/${transferId}/files/${fileId}`;

export const getTreezorOperationFilePath = ({
  accountId,
  transactionId,
  fileId,
}: {
  accountId: string;
  transactionId: string;
  fileId: string;
}) => `accounts/${accountId}/treezorOperations/${transactionId}/files/${fileId}`;

export function getContractCustomFilePath({ accountId }: { accountId: string }) {
  return `accounts/${accountId}/contract`;
}

export function getContractTemplateFilePath({
  supervisorOrgId,
  templateId,
}: {
  supervisorOrgId: string;
  templateId: string;
}) {
  return `supervisorOrg/${supervisorOrgId}/contractTemplates/${templateId}`;
}

export function getContractTemplateTempFilePath({
  supervisorOrgId,
  templateId,
}: {
  supervisorOrgId: string;
  templateId: string;
}) {
  return `supervisorOrg/${supervisorOrgId}/contractTemplatesTemp/${templateId}`;
}

export function getAvatarOriginalFilePath({ supervisorOrgId }: { supervisorOrgId: string }) {
  return `supervisorOrg/${supervisorOrgId}/avatar/original`;
}

export function getAvatarThumbnailFilePath({ supervisorOrgId }: { supervisorOrgId: string }) {
  return `supervisorOrg/${supervisorOrgId}/avatar/thumbs/original_200x200`;
}
